import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import PanelBanner from "./landingPage/PanelBanner/PanelBanner";
import PanelDetails from "./landingPage/PanelBanner/PanelDetails";
import Login from "./auth/SignIn/Login";
import Signup from "./auth/SignIn/Signup";
import ForgotPassword from "./auth/ForgotPassword";
import ContentBlocks from "./contentblocks/ContentBlocks";
import EnquiryForm from "./enquiry/enquiryForm";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      {/* <Routes>
        <Route path="/" element={<App />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/panel" element={<PanelBanner />} />
        <Route path="/panel-info" element={<PanelDetails />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/content-blocks"
          element={
            <>
              <ContentBlocks />
            </>
          }
        />
        <Route path="/enquiry" element={<EnquiryForm />} />

      </Routes> */}
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
